// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-case-nav .nav-link.active {
  background-color: #3a516e;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/edozvola/case-submission/case-submission.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF","sourcesContent":[".new-case-nav .nav-link.active {\n  background-color: #3a516e;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
